export default __webpack_public_path__ + "static/media/check_orange_icon.64f1c6af.svg";